import { useQuery } from '@tanstack/react-query';
import { handleAxiosError } from 'core/notifications';
import camelCase from 'lodash/camelCase';

import axios from '@/util/axios';

import getAxiosConfig from '../helpers/getAxiosConfig';
import transformAccessRulesToModel from '../helpers/transformAccessRulesToModel';
import useGlobalQueries from './useGlobalQueries';

export default (classType) => {
  const { currentUser } = useGlobalQueries();
  const userId = currentUser.data?.id;
  const isUnrestrictedAdmin = Boolean(currentUser.data?.authority === 'superadmin');

  const query = useQuery({
    enabled: Boolean(userId && classType && !isUnrestrictedAdmin),
    onError: handleAxiosError,
    queryFn: async () => (await axios(getAxiosConfig('get-access-rules', { userId }))).data,
    queryKey: ['permissionsAccess', userId, classType],
  });

  const rules = query.data?.data?.access_rules;
  const model = rules && transformAccessRulesToModel(rules);
  const access = model?.[camelCase(classType)]?.access;
  const enforcementRule = model?.[camelCase(classType)]?.enforcement_rule;

  return {
    access,
    enforcementRule,
    isLoading: !isUnrestrictedAdmin && query.isLoading,
    isUnrestrictedAdmin,
    query,
  };
};
